function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.95 19.062a.804.804 0 0 1-.67-1.245c.738-1.094 1.125-2.381 1.125-3.719s-.387-2.625-1.125-3.721a.796.796 0 0 1 .216-1.106a.797.797 0 0 1 1.108.214A8.266 8.266 0 0 1 24 14.105a8.268 8.268 0 0 1-1.396 4.619a.73.73 0 0 1-.645.359l-.009-.021zm-2.29-1.294a.784.784 0 0 1-.445-.139a.777.777 0 0 1-.215-1.094a4.275 4.275 0 0 0 .747-2.43c0-.855-.258-1.695-.747-2.431c-.248-.36-.154-.854.215-1.095s.857-.15 1.106.225a5.922 5.922 0 0 1 1.021 3.314c0 1.201-.352 2.34-1.021 3.315a.767.767 0 0 1-.661.36v-.025zm-3.73-7.153a6.331 6.331 0 0 0-6.3-5.699a6.349 6.349 0 0 0-5.995 4.283C1.588 9.501 0 11.269 0 13.4a4.264 4.264 0 0 0 4.26 4.254h10.908a3.566 3.566 0 0 0 3.566-3.557c0-1.706-1.2-3.129-2.805-3.48v-.002zm-.762 5.446H4.263a2.67 2.67 0 0 1-2.669-2.658a2.664 2.664 0 0 1 2.669-2.658c.71 0 1.381.285 1.886.781a.79.79 0 0 0 1.125 0c.3-.301.3-.811 0-1.125A4.288 4.288 0 0 0 5.309 9.29a4.728 4.728 0 0 1 4.305-2.774a4.75 4.75 0 0 1 4.74 4.738c0 .512-.075 1.006-.24 1.486a.819.819 0 0 0 .75 1.065a.79.79 0 0 0 .75-.54c.105-.315.18-.63.225-.96a1.977 1.977 0 0 1 1.26 1.83a1.973 1.973 0 0 1-1.965 1.979l.034-.053z",
  fill: "#626262"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 24,
  height: 24,
  fill: "rgba(0, 0, 0, 0)"
});
const SvgMixcloud = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMixcloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mixcloud.a5f9367d.svg";
export { ForwardRef as ReactComponent };